import { Injectable } from '@angular/core';
import { AdvancedConditions, CustomRule, DisplayOptions, Filter } from '../../models/filter-models';
import { WaystoneFilterType } from "../../models/enums";
import { DisplayType, EquipmentTierType } from "../../models/enums";
import { Comparator, Rarity, YesNoAny } from "../../models/enums";
import { Tier } from '../../models/item-data-models';
import { EquipmentType } from '../../models/equipment-type.enum';
import { RuleGeneratorService } from './rule-generator.service';
import { GenerationHelperService } from './generation-helper.service';


@Injectable({
  providedIn: 'root'
})
export class PoE1MapGeneratorService {
  constructor(
    private ruleGeneratorService: RuleGeneratorService,
    private helper: GenerationHelperService
  ) { }

  public generatePoE1MapRules(filter: Filter) {
    if (!filter.dynamicWaystones) return { filterText: '', dynamicWaystoneThresholds: undefined };

    let poe1Lvl17Style = '', poe1Lvl17CorruptedStyle = '',
      poe1Lvl16BlightRavagedStyle = '', poe1Lvl16BlightRavagedCorruptedStyle = '',
      poe1Lvl16memoryStrandsStyle = '',  poe1Lvl16MemoryStrandsCorruptedStyle = '',
      poe1Lvl16influencedStyle = '', poe1Lvl16BlightedStyle = '', poe1Lvl16DeliriumStyle = '', poe1Lvl16EightModStyle = '',
      poe1LowLvlmemoryStrandsStyle = '', poe1LowLvlBlightedStyle = '', poe1LowLvlDeliriumStyle = '',
      poe1Lvl15Style = '';

    const beforeEndgame = filter.waystoneFilterType !== WaystoneFilterType.StaticStrict;

    poe1Lvl17Style = this.ruleGeneratorService.generateEquipmentRule(EquipmentType.MapsTier17, new CustomRule({
      rarity: Rarity.Rare,
      rarityComparator: Comparator.LessThanOrEqual,
      itemClass: 'Maps',
      baseTypes: ['Nightmare Map'],
    }), filter, 'Nightmare Maps', undefined, undefined, filter.mapTypesT17 || beforeEndgame);

    poe1Lvl17CorruptedStyle = this.ruleGeneratorService.generateEquipmentRule(EquipmentType.MapsTier17Corrupted, new CustomRule({
      rarity: Rarity.Rare,
      rarityComparator: Comparator.LessThanOrEqual,
      itemClass: 'Maps',
      baseTypes: ['Nightmare Map'],
      advancedConditions: new AdvancedConditions({ corrupted: YesNoAny.Yes, eightModMap: true }),
    }), filter, 'Corrupted Nightmare Maps', undefined, undefined, filter.mapTypesT17Corrupted || beforeEndgame);

    poe1Lvl16memoryStrandsStyle = this.ruleGeneratorService.generateEquipmentRule(EquipmentType.MapsTier16MemoryInfluenced, new CustomRule({
      rarity: Rarity.Rare,
      rarityComparator: Comparator.LessThanOrEqual,
      itemClass: 'Maps',
      advancedConditions: new AdvancedConditions({ waystoneMinTier: 16, zanaMemory: true }),
    }), filter, 'Memory-Influenced Tier 16 Maps', undefined, undefined, filter.mapTypesT16MemoryInfluenced || beforeEndgame);

    poe1Lvl16MemoryStrandsCorruptedStyle = this.ruleGeneratorService.generateEquipmentRule(EquipmentType.MapsTier16MemoryInfluencedCorrupted, new CustomRule({
      rarity: Rarity.Rare,
      rarityComparator: Comparator.LessThanOrEqual,
      itemClass: 'Maps',
      advancedConditions: new AdvancedConditions({ waystoneMinTier: 16, zanaMemory: true, corrupted: YesNoAny.Yes, eightModMap: true }),
    }), filter, 'Corrupted Memory-Influenced Tier 16 Maps', undefined, undefined, filter.mapTypesT16MemoryInfluencedCorrupted || beforeEndgame);

    poe1Lvl16influencedStyle = this.ruleGeneratorService.generateEquipmentRule(EquipmentType.MapsTier16Influenced, new CustomRule({
      rarity: Rarity.Rare,
      rarityComparator: Comparator.LessThanOrEqual,
      itemClass: 'Maps',
      advancedConditions: new AdvancedConditions({ waystoneMinTier: 16, hasInfluence: true }),
    }), filter, 'Influenced Tier 16 Maps', undefined, undefined, filter.mapTypesT16Influenced || beforeEndgame);

    poe1Lvl16BlightRavagedStyle = this.ruleGeneratorService.generateEquipmentRule(EquipmentType.MapsTier16BlightRavaged, new CustomRule({
      rarity: Rarity.Rare,
      rarityComparator: Comparator.LessThanOrEqual,
      itemClass: 'Maps',
      advancedConditions: new AdvancedConditions({ blightRavagedMap: true }),
    }), filter, 'Blight Ravaged Maps', undefined, undefined, filter.mapTypesBlightRavaged || beforeEndgame);

    poe1Lvl16BlightRavagedCorruptedStyle = this.ruleGeneratorService.generateEquipmentRule(EquipmentType.MapsTier16BlightRavagedCorrupted, new CustomRule({
      rarity: Rarity.Rare,
      rarityComparator: Comparator.LessThanOrEqual,
      itemClass: 'Maps',
      advancedConditions: new AdvancedConditions({ blightRavagedMap: true, corrupted: YesNoAny.Yes, eightModMap: true }),
    }), filter, 'Corrupted Blight Ravaged Maps', undefined, undefined, filter.mapTypesBlightRavagedCorrupted || beforeEndgame);

    poe1Lvl16EightModStyle = this.ruleGeneratorService.generateEquipmentRule(EquipmentType.MapsTier16EightMod, new CustomRule({
      rarity: Rarity.Rare,
      rarityComparator: Comparator.LessThanOrEqual,
      itemClass: 'Maps',
      advancedConditions: new AdvancedConditions({ waystoneMinTier: 16, waystoneMaxTier: 16, eightModMap: true }),
    }), filter, 'Eight Mod Tier 16 Maps', undefined, undefined, filter.mapTypesT16EightMod || beforeEndgame);

    poe1Lvl16EightModStyle +=  "\n\n" + this.ruleGeneratorService.generateEquipmentRule(EquipmentType.MapsTier16EightMod, new CustomRule({
      rarity: Rarity.Rare,
      rarityComparator: Comparator.Equal,
      itemClass: 'Maps',
      advancedConditions: new AdvancedConditions({ waystoneMinTier: 16, waystoneMaxTier: 16, identified: YesNoAny.No, corrupted: YesNoAny.Yes }),
    }), filter, 'Unidentified Eight Mod Tier 16 Maps', undefined, undefined, filter.mapTypesT16EightMod || beforeEndgame) + "\n";

    poe1Lvl16DeliriumStyle = this.ruleGeneratorService.generateEquipmentRule(EquipmentType.MapsTier16Delirium, new CustomRule({
      rarity: Rarity.Rare,
      rarityComparator: Comparator.LessThanOrEqual,
      itemClass: 'Maps',
      advancedConditions: new AdvancedConditions({ waystoneMinTier: 16, anyEnchantment: true }),
    }), filter, 'Delirium Tier 16 Maps', undefined, undefined, filter.mapTypesT16Delirium || beforeEndgame);

    poe1Lvl16BlightedStyle = this.ruleGeneratorService.generateEquipmentRule(EquipmentType.MapsTier16Blighted, new CustomRule({
      rarity: Rarity.Rare,
      rarityComparator: Comparator.LessThanOrEqual,
      itemClass: 'Maps',
      advancedConditions: new AdvancedConditions({ waystoneMinTier: 16, blightedMap: true }),
    }), filter, 'Blighted Tier 16 Maps', undefined, undefined, filter.mapTypesT16Blighted || beforeEndgame);

    poe1LowLvlmemoryStrandsStyle = this.ruleGeneratorService.generateEquipmentRule(EquipmentType.MapsLowTierMemoryInfluenced, new CustomRule({
      rarity: Rarity.Rare,
      rarityComparator: Comparator.LessThanOrEqual,
      itemClass: 'Maps',
      advancedConditions: new AdvancedConditions({ waystoneMinTier: filter.mapTypesLowTierMinTier, zanaMemory: true }),
    }), filter, 'Memory-Influenced Low-Tier Maps', undefined, undefined, filter.mapTypesLowTierMemoryInfluenced || beforeEndgame);

    poe1LowLvlBlightedStyle = this.ruleGeneratorService.generateEquipmentRule(EquipmentType.MapsLowTierBlighted, new CustomRule({
      rarity: Rarity.Rare,
      rarityComparator: Comparator.LessThanOrEqual,
      itemClass: 'Maps',
      advancedConditions: new AdvancedConditions({ waystoneMinTier: filter.mapTypesLowTierMinTier, blightedMap: true }),
    }), filter, 'Blighted Low-Tier Maps', undefined, undefined, filter.mapTypesLowTierBlighted || beforeEndgame);

    poe1LowLvlDeliriumStyle = this.ruleGeneratorService.generateEquipmentRule(EquipmentType.MapsLowTierDelirium, new CustomRule({
      rarity: Rarity.Rare,
      rarityComparator: Comparator.LessThanOrEqual,
      itemClass: 'Maps',
      advancedConditions: new AdvancedConditions({ waystoneMinTier: filter.mapTypesLowTierMinTier, anyEnchantment: true }),
    }), filter, 'Delirium Low-Tier Maps', undefined, undefined, filter.mapTypesLowTierDelirium || beforeEndgame);

    poe1Lvl15Style = this.ruleGeneratorService.generateRule(new CustomRule({
      rarity: Rarity.Rare,
      rarityComparator: Comparator.LessThanOrEqual,
      itemClass: 'Maps',
      advancedConditions: new AdvancedConditions({ waystoneMaxTier: filter.mapTypesT16Normal ? 15 : 16 }),
      displayOptions: new DisplayOptions({ active: true, hidden: true })
    }), filter, 'maps-tier-15', 'Tier 15- Maps');

    const defaultGoodMapStyles = poe1Lvl17CorruptedStyle + '\n' + poe1Lvl17Style + '\n'
    + poe1Lvl16MemoryStrandsCorruptedStyle + '\n' + poe1Lvl16memoryStrandsStyle + '\n'
    + poe1Lvl16BlightRavagedStyle + '\n'
    + poe1Lvl16influencedStyle + '\n' + poe1Lvl16BlightedStyle + '\n' + poe1Lvl16DeliriumStyle + '\n';

    if (filter.waystoneFilterType === WaystoneFilterType.StaticStrict) {
      const lvl16NormalStyle = filter.mapTypesT16Normal ? this.ruleGeneratorService.generateEquipmentRule(EquipmentType.MapsTier16Normal, new CustomRule({
        rarity: Rarity.Rare,
        rarityComparator: Comparator.LessThanOrEqual,
        itemClass: 'Maps',
        advancedConditions: new AdvancedConditions({ waystoneMinTier: 16, waystoneMaxTier: 16 }),
      }), filter, 'Normal Tier 16 Maps', undefined, undefined, filter.mapTypesT16Normal) : '';

      return {
        filterText: defaultGoodMapStyles
          + poe1Lvl16EightModStyle + '\n'
          + poe1Lvl16BlightRavagedCorruptedStyle + '\n'
          + poe1LowLvlmemoryStrandsStyle + '\n'
          + lvl16NormalStyle + '\n'
          + poe1LowLvlBlightedStyle + '\n' + poe1LowLvlDeliriumStyle + '\n' + poe1Lvl15Style,
        dynamicWaystoneThresholds: undefined
      };
    } else if (filter.waystoneFilterType === WaystoneFilterType.StaticDefault) {
      const lvl11Style = this.ruleGeneratorService.generateEquipmentRule(EquipmentType.MapsTier11, new CustomRule({
        rarity: Rarity.Rare,
        rarityComparator: Comparator.LessThanOrEqual,
        itemClass: 'Maps',
        advancedConditions: new AdvancedConditions({ waystoneMinTier: 11 }),
      }), filter, 'Tier 11+ Maps');

      const lvl6Style = this.ruleGeneratorService.generateEquipmentRule(EquipmentType.MapsTier6, new CustomRule({
        rarity: Rarity.Rare,
        rarityComparator: Comparator.LessThanOrEqual,
        itemClass: 'Maps',
        advancedConditions: new AdvancedConditions({ waystoneMinTier: 6 }),
      }), filter, 'Tier 6+ Maps');

      const lvl1Style = this.ruleGeneratorService.generateEquipmentRule(EquipmentType.MapsTier1, new CustomRule({
        rarity: Rarity.Rare,
        rarityComparator: Comparator.LessThanOrEqual,
        itemClass: 'Maps',
        advancedConditions: new AdvancedConditions({ waystoneMinTier: 1 }),
      }), filter, 'Tier 1+ Maps');

      return {
        filterText: defaultGoodMapStyles + poe1Lvl16EightModStyle
          + poe1LowLvlmemoryStrandsStyle + '\n' + poe1LowLvlBlightedStyle + '\n' + poe1LowLvlDeliriumStyle + '\n'
          + lvl11Style + '\n' + lvl6Style + '\n' + lvl1Style,
        dynamicWaystoneThresholds: undefined
      };
    } else {
      const currLevel = filter.dynamicWaystonesLevel || 1;

      const showFrom = currLevel - 3;
      const highlightTiers = [
        { level: Math.min(currLevel + 2, 16), tier: Tier.BOrange },
        { level: Math.min(currLevel, 15), tier: Tier.CYellow },
        { level: Math.min(currLevel - 1, 14), tier: Tier.DWhite },
      ];

      const dynamicWaystoneThresholds = [
        { level: showFrom > 1 ? '< ' + showFrom.toString() : '🞪' },
        { level: currLevel > 2 ? '≥ ' + Math.max(showFrom, 1) : '🞪' },
        { level: highlightTiers[2].level >= 1 ? '≥ ' + highlightTiers[2].level : '🞪' },
        { level: highlightTiers[1].level >= 1 ? '≥ ' + highlightTiers[1].level : '🞪' },
        { level: highlightTiers[0].level >= 1 ? '≥ ' + highlightTiers[0].level : '🞪' },
      ];

      let text = '';

      for (let threshold of highlightTiers) {
        if (threshold.level >= 1) {
          const rule = new CustomRule({
            advancedConditions: new AdvancedConditions({ waystoneMinTier: Math.max(threshold.level, 1) }),
            displayOptions: new DisplayOptions({ active: true, displayType: DisplayType.EquipmentTier, displayTypeTierHighlightType: EquipmentTierType.Map, displayTypeTier: threshold.tier })
          });
          rule.itemClass = 'Maps';
          text += this.ruleGeneratorService.generateRule(rule, filter, 'maps-dynamic', 'Dynamic Maps') + '\n';
        }
      }

      if (currLevel > 2) {
        const rule = new CustomRule({
          advancedConditions: new AdvancedConditions({ waystoneMinTier: Math.max(showFrom, 1) }),
          displayOptions: new DisplayOptions({ active: true, displayType: DisplayType.EquipmentTier, displayTypeTierHighlightType: EquipmentTierType.Map, displayTypeTier: Tier.EVisible })
        });
        rule.itemClass = 'Maps';
        text += this.ruleGeneratorService.generateRule(rule, filter, 'maps-dynamic', 'Dynamic Maps') + '\n';
      }

      if (showFrom > 1) {
        const rule = new CustomRule({
          advancedConditions: new AdvancedConditions({ waystoneMaxTier: showFrom -1 }),
          displayOptions: new DisplayOptions({ active: true, hidden: true })
        });
        rule.itemClass = 'Maps';
        text += this.ruleGeneratorService.generateRule(rule, filter, 'maps-dynamic', 'Dynamic Maps') + '\n';
      }

      text = defaultGoodMapStyles + poe1Lvl16EightModStyle
        + poe1LowLvlmemoryStrandsStyle + '\n' + poe1LowLvlBlightedStyle + '\n' + poe1LowLvlDeliriumStyle + '\n' + text;

      return { filterText: text.trimEnd(), dynamicWaystoneThresholds: dynamicWaystoneThresholds };
    }
  }
}
